import { apiSlice } from '../../app/api/apiSlice'
import { encodeBase64 } from '../../helpers/images';

export const skuImageApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProductImage: builder.query ({
      query: ({sku_id, side, width}) => ({
        url: `v2/skupreview/${sku_id}/${side}/${width}`,
        method: 'GET',
        responseHandler: (response) => response.blob()
      }),
      keepUnusedDataFor: 5,
      transformResponse: async (response, meta) => {
        const img = await encodeBase64(response);
        return img;
      },
    }),
    downloadProductImage: builder.query ({
      query: ({skuimage_id}) => ({
        url: `v2/skuimage/${skuimage_id}/download`,
        method: 'GET',
        responseHandler: (response) => response.blob()
      }),
      keepUnusedDataFor: 5,
      transformResponse: async (response, meta) => {
        const img = await encodeBase64(response);
        return img;
      },
    }),
    getProductFamilyImage: builder.query ({
      query: ({family_id, width}) => ({
        url: `v2/productfamilypreview/${family_id}/${width}`,
        method: 'GET',
        responseHandler: (response) => response.status === 200 ? response.blob() : null
      }),
      keepUnusedDataFor: 5,
      transformResponse: async (response, meta) => {
        if(response instanceof Blob) {
          const img = await encodeBase64(response);
          return img;
        }
        return null;
      },
    }),
    uploadProductImage: builder.mutation ({
      query: ({sku_id, purpose, data}) => ({
        url: `v2/sku/${sku_id}/upload_image/${purpose}`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["SKUImage"]
    })
  }),
})


export const {
    useGetProductImageQuery,
    useDownloadProductImageQuery,
    useGetProductFamilyImageQuery,
    useUploadProductImageMutation
} = skuImageApi
